<template>
  <div>
    <v-toolbar class="mx-3" flat color="transparent">
      <v-btn :to="{ name: 'locacoes_page' }" icon exact>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title> {{ codigo }} </v-toolbar-title>
    </v-toolbar>
    <v-container fluid v-if="locacao !== null">
      <v-alert
        v-if="locacao.cancelado"
        type="error"
        outlined
        text
        border="left"
      >
        Cancelado
      </v-alert>
      <v-alert
        v-else-if="locacao.aberto"
        type="info"
        outlined
        text
        border="left"
      >
        Aberto
      </v-alert>
      <v-alert v-else type="info" outlined text border="left">
        Fechado
      </v-alert>
      <v-row>
        <v-col>
          <EstadoLocacaoCard
            :locacao="locacao"
            @aprovado="locacao = $event"
            @reprovado="locacao = $event"
          ></EstadoLocacaoCard>
        </v-col>
      </v-row>
      <PagamentoAlert
        :pago="locacao.pago"
        :total_pago="locacao.total_pago"
        :total="Number.parseFloat(locacao.total)"
        :locacao_codigo="locacao.codigo"
        :locacao_fechada="!locacao.aberto && !locacao.cancelado"
        @changed="locacao = $event"
      />
      <v-card>
        <v-card-title>
          Produtos
          <v-spacer></v-spacer>
          <v-btn
            v-if="locacao.aberto"
            @click="clicarAdicionarProduto()"
            color="primary"
            text
          >
            <v-icon left>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <template v-for="produto in locacao.produtos">
            <v-list-item @click="clicarProduto(produto)" :key="produto.id" link>
              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{ produto.quantidade }}x</strong>
                  {{ produto.produto_nome }}
                </v-list-item-title>
                <template v-if="!locacao.aberto">
                  <v-list-item-subtitle>
                    Un.: {{ formatMoney(produto.preco_unitario) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Entregues: {{ produto.quantidade_entregue }}/{{
                      produto.quantidade
                    }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Recolhidos: {{ produto.quantidade_recolhida }}/{{
                      produto.quantidade
                    }}
                  </v-list-item-subtitle>
                </template>
                <template v-else>
                  <v-list-item-subtitle>
                    Un.: {{ formatMoney(produto.preco_unitario) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Data inicio: {{ formatDate(produto.data_inicial) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Data final: {{ formatDate(produto.data_final) }}
                  </v-list-item-subtitle>
                </template>
              </v-list-item-content>
              <v-list-item-action>
                <div>
                  <span class="d-none d-sm-inline">
                    {{ formatMoney(produto.total) }}
                  </span>
                  <v-btn
                    @click.prevent.stop="removerProduto(produto)"
                    icon
                    color="red"
                    v-if="locacao.aberto"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="produto.id + '_divider'"></v-divider>
          </template>
          <v-list-item>
            <v-list-item-content></v-list-item-content>
            <v-list-item-action>
              <b>
                {{ formatMoney(locacao.total) }}
              </b>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>

      <v-row class="mt-4">
        <v-col cols="12" md="6">
          <v-card style="height: 100%">
            <v-card-title>Cliente</v-card-title>

            <AlertaCredito
              v-if="locacao.alerta_credito"
              :totalPedido="locacao.total"
              :limite="locacao.cliente.limite_credito_disponivel"
            ></AlertaCredito>

            <v-list v-if="locacao.cliente_id">
              <v-list-item
                link
                :to="{
                  name: 'pagina_cliente',
                  params: { id: locacao.cliente_id }
                }"
              >
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ locacao.cliente_nome }}
                    <span class="grey--text">#{{ locacao.cliente_id }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    @click.prevent="handleClienteAlterado(null)"
                    icon
                    color="red"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-card-text v-else>
              <SeletorCliente @submit="handleClienteAlterado"></SeletorCliente>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <CompradorForm
            :locacao-id="locacao.id"
            :valor-inicial="locacao.comprador"
            :readonly="!locacao.aberto"
          ></CompradorForm>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6">
          <v-card style="height: 100%">
            <v-card-title>
              Forma de pagamento
            </v-card-title>
            <v-card-text>
              <payment-type-picker
                @change="atualizarFormaDePagamento"
                :value="locacao.forma_pagamento_id"
                filled
                :readonly="!locacao.aberto"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card height="100%">
            <v-card-title>Endereço de entrega</v-card-title>
            <AddressPicker
              v-show="!!locacao.cliente_id"
              :client_id="locacao.cliente_id"
              :current_address="locacao.endereco"
              :readonly="!locacao.aberto"
              ref="addressPicker"
              @change="handleMudancaEndereco"
              @addressesLoaded="handleAddressesLoaded"
            />
            <v-list-item v-show="!!!locacao.cliente_id">
              <v-list-item-content>
                <v-list-item-title>
                  Identifique o cliente antes de escolher o local da entrega
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Total
              <v-spacer></v-spacer>
              {{ formatMoney(locacao.total) }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <EstadoLocacaoCard
            :locacao="locacao"
            @aprovado="locacao = $event"
            @reprovado="locacao = $event"
          ></EstadoLocacaoCard>
        </v-col>
      </v-row>

      <v-card class="mt-5">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn @click="print_dialog = true" text color="primary">
            <v-icon left>mdi-printer</v-icon>
            Imprimir
          </v-btn>
          <v-btn
            @click="cancelarLocacao()"
            v-if="!locacao.cancelado"
            text
            color="red"
          >
            <v-icon left>mdi-delete</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            v-if="locacao.estado_locacao.id === 'aberto'"
            @click="fechar()"
            color="primary"
            large
            :loading="fechando"
          >
            <v-icon left>mdi-cart</v-icon>
            Fechar
          </v-btn>
        </v-card-title>
      </v-card>
    </v-container>
    <v-container class="text-center" v-else>
      <v-progress-circular
        indeterminate
        color="primary"
        class="mt-12"
      ></v-progress-circular>
    </v-container>

    <LocacaoProdutoDialog
      ref="produto_dialog"
      :locacao_id="locacao.id"
      @product_added="locacao = $event"
    />

    <confirm-print
      v-model="print_dialog"
      @action="printLocacao"
      :default_copies="2"
      message="Tem certeza que deseja imprimir o recibo desta locação?"
    />

    <ConfirmationDialog ref="confirmation"></ConfirmationDialog>
    <HistoricoProdutoDialog ref="historico"></HistoricoProdutoDialog>
  </div>
</template>

<script>
import alerts from "@/mixins/alerts.js";
import MoneyMixin from "@/mixins/MoneyMixin.js";
import DateTimeMixin from "@/mixins/DateTimeMixin.js";
import api from "@/services/locacoes.js";
import ConfirmPrint from "@/components/ConfirmPrint";
import LocacaoProdutoDialog from "@/components/locacoes/locacoes/LocacaoProdutoDialog.vue";
import PaymentTypePicker from "@/components/PaymentTypePicker";
import { printLocacao } from "@/services/print";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import PagamentoAlert from "../../components/locacoes/locacoes/PagamentoAlert.vue";
import EstadoLocacaoCard from "@/components/locacoes/locacoes/EstadoLocacaoCard.vue";
import SeletorCliente from "../../components/clientes/SeletorCliente.vue";
import AddressPicker from "@/components/AddressPicker";
import HistoricoProdutoDialog from "../../components/locacoes/locacoes/HistoricoProdutoDialog.vue";
import CompradorForm from "../../components/CompradorForm.vue";
import AlertaCredito from "@/components/AlertaCredito.vue";

export default {
  props: {
    codigo: String
  },

  components: {
    LocacaoProdutoDialog,
    PaymentTypePicker,
    ConfirmPrint,
    ConfirmationDialog,
    PagamentoAlert,
    EstadoLocacaoCard,
    SeletorCliente,
    AddressPicker,
    HistoricoProdutoDialog,
    CompradorForm,
    AlertaCredito
  },

  mixins: [alerts, MoneyMixin, DateTimeMixin],

  data() {
    return {
      carregando: false,
      locacao: null,
      fechando: false,
      print_dialog: false
    };
  },

  methods: {
    handleAddressesLoaded() {
      this.$refs.addressPicker.form_id = this.locacao.endereco_id || 0;
    },

    async handleMudancaEndereco(endereco) {
      if (endereco == this.locacao.endereco_id) {
        return;
      }

      if (endereco === "novo") {
        console.log("Endereço Outro");
        this.$router.push({
          name: "locacoes_locacao_novo_endereco",
          params: {
            codigo: this.codigo
          }
        });

        return;
      }

      if (!endereco) {
        this.locacao = await api.locacoes.alterarEndereco(this.codigo, {
          endereco_id: null
        });

        this.alert("Salvo!");
        return;
      }

      if (endereco.id === this.locacao.endereco_id) {
        return;
      }

      this.locacao = await api.locacoes.alterarEndereco(this.codigo, {
        endereco_id: endereco.id
      });

      this.alert("Salvo!");
    },

    async handleClienteAlterado(cliente) {
      const cliente_id = cliente ? cliente.id : null;

      const locacao = await api.locacoes.alterarCliente(this.locacao.id, {
        cliente_id
      });

      this.locacao = locacao;

      this.alert("Salvo");
    },

    async printLocacao(payload) {
      try {
        await printLocacao(this.locacao.id, payload);

        this.alert("Recibo da locação foi enviado para impressão");
      } catch (error) {
        this.alert("Não foi possível enviar este recibo para impressão");
      }
    },

    async atualizarFormaDePagamento(forma_pagamento_id) {
      if (!this.locacao.aberto) {
        this.alert("Locação fechada");
        return;
      }

      const locacao = await api.locacoes.atualizarFormaDePagamento(
        this.locacao.id,
        {
          forma_pagamento_id
        }
      );

      this.locacao = locacao;

      this.alert("Salvo");
    },

    async loadLocation() {
      this.locacao = null;
      this.carregando = true;
      try {
        this.locacao = await api.locacoes.detalhar(this.codigo);
      } catch (error) {
        console.error(error);
        this.error("Não foi possível carregar a locação");
      } finally {
        this.carregando = false;
      }
    },

    clicarAdicionarProduto() {
      this.$refs.produto_dialog.abrir();
    },

    async removerProduto(produto) {
      if (!confirm("Tem certeza que deseja remover o produto?")) {
        return;
      }

      this.locacao = await api.locacoes.removerProduto(
        this.locacao.id,
        produto.id
      );
    },

    clicarProduto(produto) {
      if (!this.locacao.aberto) {
        this.$refs.historico.abrir(produto);
        return;
      }

      this.$refs.produto_dialog.abrir(produto);
    },

    async fechar() {
      this.fechando = true;

      try {
        this.locacao = await api.locacoes.fechar(this.locacao.id);
        this.alert("Locação fechada com sucesso");
      } catch (error) {
        console.error(error);
        this.handleRequestError(error, "Nâo foi possível fechar a locação");
      } finally {
        this.fechando = false;
      }
    },

    cancelarLocacao() {
      this.$refs.confirmation.confirm(
        "Cancelar locação?",
        async ({ close, startLoading, stopLoading, setError, resetError }) => {
          resetError();
          startLoading();
          try {
            const resposta = await api.locacoes.cancelar(this.locacao.id);
            close();

            if (resposta.status === 200) {
              this.locacao = resposta.data.data;
            }

            this.$router.back();
          } catch (error) {
            if (error.response.status === 400) {
              setError(error.response.data.message);
              return;
            }

            setError(error);
          } finally {
            stopLoading();
          }
        },
        null,
        {
          color: "red",
          confirmText: "Cancelar locação"
        }
      );
    }
  },

  mounted() {
    this.loadLocation();
  }
};
</script>
